import {
  $get, $post, $JsonPost, jes,
} from '@/utils/axios-request';

import Vue from 'vue';

class Study {
  // 学习记录列表
  public async studyRecordList(postData:any): Promise<any> {
    return await $get(`${jes}/studyRecord/api/v1/studyRecordList`, postData);
  }

  // 开始学习
  public async startLearning(postData:any): Promise<any> {
    return await $get(`${jes}/startLearning/api/v1/startLearning`, postData);
  }

  // 交卷
  public async handInHand(postData:any): Promise<any> {
    return await $post(`${jes}/handInHand/api/v1/handInHand`, postData);
  }

  // 暂存
  public async temporaryStorage(postData:any): Promise<any> {
    return await $JsonPost(`${jes}/handInHand/api/v1/temporaryStorage`, postData);
  }

  // 获取暂存
  public async queryTemporaryStorage(postData:any): Promise<any> {
    return await $JsonPost(`${jes}/handInHand/api/v1/queryTemporaryStorage`, postData);
  }

  // 回顾复习
  public async review(postData:any): Promise<any> {
    return await $get(`${jes}/studyRecord/api/v1/review`, postData);
  }
}
export default new Study();
